import { parseInboundPayload } from '../../inbound';
import { booleanParser, numberParser, stringParser } from '../../inboundParsers';
import { splitWithBraces, trimBraces } from '../../inboundUtils';
const SELF_DATA_PART_DEFINITIONS = [
    { name: 'sessionId', parser: stringParser },
    { name: 'id', parser: numberParser },
    { name: 'username', parser: stringParser },
    { name: 'numJacks', parser: numberParser },
    { name: 'numAmmo', parser: numberParser },
    { name: 'numChips', parser: numberParser },
    { name: 'isAdmin', parser: booleanParser },
    { name: 'isHelper', parser: booleanParser },
    { name: 'isPowerPlayer', parser: booleanParser },
    { name: 'isTempPlayer', parser: booleanParser },
    { name: 'hasFullLogin', parser: booleanParser },
    { name: 'isPromoPowerPlayerAvailable', parser: booleanParser },
    { name: 'arePowerPlayerAdsEnabled', parser: booleanParser },
    { name: 'rebuyDelaySecondsLeft', parser: numberParser },
    { name: 'freeDailyBonusSecondsLeft', parser: numberParser }
];
export function inboundSelfDataParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, SELF_DATA_PART_DEFINITIONS);
}
